import { render, staticRenderFns } from "./particles.vue?vue&type=template&id=5255b175&scoped=true"
import script from "./particles.vue?vue&type=script&lang=js"
export * from "./particles.vue?vue&type=script&lang=js"
import style0 from "./particles.vue?vue&type=style&index=0&id=5255b175&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255b175",
  null
  
)

export default component.exports